// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"222":"b4731a80","596":"27f28591"}[chunkId] + ".chunk.js";
};